module.exports = __webpack_public_path__ + "static/media/logo.5e675c91.png";